import {ValueObject} from '@s-ui/domain'

export class SubcriptionsInfoAdValueObject extends ValueObject {
  #colors
  #commitments
  #hasStock
  #price
  #selectedMonthlyPrice
  #taxesIncluded
  #vehicleState

  constructor({colors, commitments, hasStock, price, selectedMonthlyPrice, taxesIncluded, vehicleState}) {
    super()
    this.#colors = colors
    this.#commitments = commitments
    this.#hasStock = hasStock
    this.#price = price
    this.#selectedMonthlyPrice = selectedMonthlyPrice
    this.#taxesIncluded = taxesIncluded
    this.#vehicleState = vehicleState
  }

  static create({colors, commitments, hasStock, price, selectedMonthlyPrice, taxesIncluded, vehicleState}) {
    return new SubcriptionsInfoAdValueObject({
      colors,
      commitments,
      hasStock,
      price,
      selectedMonthlyPrice,
      taxesIncluded,
      vehicleState
    })
  }

  get includesTaxes() {
    if (typeof this.#price.hasTaxes !== 'undefined') return this.#price.hasTaxes
    if (typeof this.#taxesIncluded !== 'undefined') return this.#taxesIncluded
  }

  // Backend recommends always reading the selected commitment; the cheapest-of-commitments
  // reduce below only covers ads where no selected commitment was mapped
  get monthlySubscriptionFee() {
    if (typeof this.#selectedMonthlyPrice === 'number') return this.#selectedMonthlyPrice

    return this.#commitments.reduce((minimumMonthlyFee, {monthlyPrice}) => {
      if (minimumMonthlyFee === 0) return monthlyPrice
      return monthlyPrice < minimumMonthlyFee ? monthlyPrice : minimumMonthlyFee
    }, 0)
  }

  get hasMonthlySubscriptionFee() {
    return typeof this.#selectedMonthlyPrice === 'number' || Boolean(this.#commitments?.length)
  }

  get colors() {
    return this.#colors
  }

  get commitments() {
    return this.#commitments
  }

  get hasStock() {
    return this.#hasStock
  }

  get price() {
    return this.#price
  }

  get selectedMonthlyPrice() {
    return this.#selectedMonthlyPrice
  }

  get taxesIncluded() {
    return this.#taxesIncluded
  }

  get vehicleState() {
    return this.#vehicleState
  }

  toJSON() {
    return {
      colors: this.#colors,
      commitments: this.#commitments,
      hasStock: this.#hasStock,
      price: this.#price,
      selectedMonthlyPrice: this.#selectedMonthlyPrice,
      taxesIncluded: this.#taxesIncluded,
      vehicleState: this.#vehicleState
    }
  }
}
